export default __webpack_public_path__ + "static/media/User_box_light.e8d9f2d2.svg";